import React from "react"
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'


interface OwnProps {
  imageData: IGatsbyImageData;
}

type QRCodeProps = OwnProps

export const QRCode: React.FC<QRCodeProps> = ({
  imageData
}) => {
  return (
    <div className="hidden mt-5 md:block">
      <GatsbyImage
        alt="QR Code"
        image={imageData}
      />
    </div>
  )
}
